export default "__VITE_ASSET__f3a383b8__"